import React, { useState } from 'react'
import AddNewAppointment from '../../../../../../../../../../Scheduler/AddNewAppointment';
import { IconAppintmentNotFound } from '../../../../../../../../../../shared/IconsComponent/icons';

const Appointments = ({ data, setIsRecordSaved, expandAll }) => {
  const [viewAll, setViewAll] = useState(false);
  const [isOpenAppointment, setIsOpenAppointment] = useState(false);
  const [appointmentID, setAppointmentID] = useState();

  const AddAppointment = (ID) => {
    setAppointmentID(ID)
    setIsOpenAppointment(true);
  }
  const CloseAppointment = () => {
    setIsOpenAppointment(false)
  }

  let PopupScreen = "";
  if (isOpenAppointment) {
    PopupScreen = <AddNewAppointment AppointmentID={appointmentID} showEvents={isOpenAppointment}
      setIsRecordSaved={setIsRecordSaved} handleOnClose={CloseAppointment} />
  }
  return (
    <>
      {PopupScreen}
      <div className='content-box px-0'>
        <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1 mx-2'>
          <p className='heading fs-13'>Appointments</p>
          {data?.length > 0 ?
            <p className='heading validate-color cursor-pointer' onClick={() => setViewAll(prev => !prev)}>{viewAll ? 'Hide All' : 'View All'}</p> : null}
        </div>
        <div className='d-flex flex-column gap-2 hover-scrollbar problem-scroll px-2'>

          {expandAll &&
            (viewAll &&
              ((data?.length > 0 ?
                data.map(item => {
                  let AppointmentStatus = item?.Status.replace(" ", "-")
                  return (
                    <>
                      <p className={`pill w-max-content ${AppointmentStatus}`}>{item?.Status}</p>
                      <p className='text validate-color cursor-pointer font-m' onClick={() => AddAppointment(item.PatientAppointmentID)}>{item?.AppointmentTimeFrom}</p>
                      <p className='text'>Visit Type: {item?.VisitType}</p>
                      <p className='text'>CC: {item?.ChiefComplain}</p>
                    </>
                  )
                }

                ) :
                <></>
              )))}
        </div>
        {data?.length === 0 &&
          <div className='d-flex align-items-center justify-content-center flex-column row-gap-5 ar-apt-notFound'>
            <div className='ar-apt-notFound_Icon'>
              <IconAppintmentNotFound />
            </div>
            <p className='text fst-italic font-m ar-light-color'>No Appointments Found!</p>
          </div>
        }
      </div >
    </>
  )
}

export default Appointments